if (!customElements.get('press-slider')) {
  customElements.define(
    'press-slider',
    class PressSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.main = this.querySelector('.press-testimonials');
        this.thumbs = this.querySelector('.press-thumbs');

        this.mainSlider = this.main.querySelector('.swiper');
        this.thumbsSlider = this.thumbs.querySelector('.swiper');

        // Split moves the arrows out of `.press-testimonials`, so resolve them from the element.
        this.prevButton = this.querySelector('.swiper-button-prev');
        this.nextButton = this.querySelector('.swiper-button-next');

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.addEventListener('change', this.init.bind(this), { signal });
        this.init();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.destroySlider();
      }

      init() {
        this.destroySlider();
        this.initSlider();
      }

      get isSplit() {
        return this.dataset.layout === 'split';
      }

      setSliderOptions() {
        this.mainOptions = {
          slidesPerView: 1,
          spaceBetween: 30,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.prevButton,
          },
          loop: true,
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
        };

        // Split only: Centered keeps Swiper's default speed (its options stay as they were).
        const noMotion = FoxTheme.config.motionReduced || FoxTheme.config.disableAnimations;
        if (this.isSplit && noMotion) this.mainOptions.speed = 0;

        const gap = Number(this.thumbs.dataset.gap);
        const gapMobile = Number(this.thumbs.dataset.gapMobile);

        if (this.isSplit) {
          this.thumbsOptions = {
            slidesPerView: 'auto',
            spaceBetween: gap,
            freeMode: true,
            threshold: 2,
          };

          if (noMotion) this.thumbsOptions.speed = 0;

          if (FoxTheme.config.mqlMobile) {
            this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
              slidesPerView: 1,
              spaceBetween: gapMobile,
              centeredSlides: true,
              freeMode: false,
            });
          }
          return;
        }

        const thumbsDesktopItems = Number(this.thumbs.dataset.itemsDesktop);
        const thumbsTabletLargeItems = Number(this.thumbs.dataset.itemsTabletLarge);
        const thumbsTabletItems = Number(this.thumbs.dataset.itemsTablet);

        this.thumbsOptions = {
          slidesPerView: 'auto',
          spaceBetween: gapMobile,
          breakpoints: {
            768: {
              slidesPerView: thumbsTabletItems,
              spaceBetween: gap,
              centeredSlides: thumbsTabletItems % 2 === 0 ? false : true,
              loop: thumbsTabletItems % 2 === 0 ? false : true,
            },
            1024: {
              slidesPerView: thumbsTabletLargeItems,
              spaceBetween: gap,
              centeredSlides: thumbsTabletLargeItems % 2 === 0 ? false : true,
              loop: thumbsTabletLargeItems % 2 === 0 ? false : true,
            },
            1280: {
              slidesPerView: thumbsDesktopItems,
              spaceBetween: gap,
              centeredSlides: false,
              loop: false,
            }
          },
          freeMode: true,
          threshold: 2,
        };

        if (FoxTheme.config.mqlMobile) {
          this.thumbsOptions = Object.assign({}, this.thumbsOptions, {
            centeredSlides: true,
            slideToClickedSlide: true,
            loop: true,
          });
        }
      }

      initSlider() {
        this.setSliderOptions();

        this.thumbsInstance = new FoxTheme.Carousel(this.thumbsSlider, this.thumbsOptions);
        this.thumbsInstance.init();

        this.mainOptions.thumbs = {
          swiper: this.thumbsInstance.slider,
          // Split on mobile shows one logo — the look-ahead offset would push it past the quote.
          autoScrollOffset: this.isSplit && FoxTheme.config.mqlMobile ? 0 : 2,
        };

        this.sliderInstance = new FoxTheme.Carousel(this.mainSlider, this.mainOptions, [FoxTheme.Swiper.Thumbs]);
        this.sliderInstance.init();

        this.sliderInstance.slider.on('realIndexChange', (swiper) => {
          const { realIndex, thumbs } = swiper;
          thumbs.swiper.slideToLoop(realIndex);
        });

        // Split on mobile shows one logo: swiping it moves the quote with it. Only a drag on the
        // logo row counts — slides the main slider triggers itself must not bounce back.
        if (this.isSplit && FoxTheme.config.mqlMobile) {
          let dragged = false;
          const thumbs = this.thumbsInstance.slider;
          thumbs.on('touchStart', () => (dragged = true));
          thumbs.on('slideChange', () => {
            if (!dragged) return;
            dragged = false;
            const main = this.sliderInstance?.slider;
            if (main && main.realIndex !== thumbs.activeIndex) main.slideToLoop(thumbs.activeIndex);
          });
        }
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;

        this.thumbsInstance.slider.destroy();
        this.thumbsInstance = false;
      }
    }
  );
}
